module.exports = __webpack_public_path__ + "static/media/NegotiationSaleOffer.57926f8f.png";